import gsap from "gsap";
import { ready } from "jquery";
import inview from 'jquery-inview/jquery.inview';

$(window).ready( function() {
    if( $('.image-with-text-cta__rotator:visible') ) {
        rotatorAnimation();
    }
});


function rotatorAnimation() {
    var count = $(".image-with-text-cta__rotator--image").length;
    $('.image-with-text-cta__rotator--image').css('animation-duration', count * 4 + 's');
}